<template>
	<div class='home-box'>
		<div class='home-bg'><img src="@/assets/home_images/home_bg.jpg"></div>
		<div class='head'>
			<div class='head-bg'>
				<div class='head-l'></div>
				<div class='head-c'><h1>智慧路灯管理平台</h1></div>
				<div class='head-r'></div>
			</div>
		</div>
		<div class='go-system' @click='$router.push("/admins")'><img src="@/assets/home_images/go_system.png"></div>
		<div class='left-top'><img src="@/assets/home_images/left_top.png"></div>
		<div class='right-top'><img src="@/assets/home_images/right_top.png"></div>
		<div class='home-left'>
			<div class='home_pad'>
				<div class='main-left-top'><box1></box1></div>
				<div class='main-left-cen'><box2></box2></div>
				<div class='main-left-bot'><box3></box3></div>
			</div>
		</div>
		<div class='home-right'>
			<div class='home_pad'>
				<div class='main-right-cen'><box4></box4></div>
				<div class='main-right-cen'><box5></box5></div>
				<div class='main-right-cen'><box6></box6></div>
				<div class='main-right-bot'><box7></box7></div>
			</div>
		</div>
	</div>
</template>
<script>
import box1 from '@/components/home/box1.vue'
import box2 from '@/components/home/box2.vue'
import box3 from '@/components/home/box3.vue'
import box4 from '@/components/home/box4.vue'
import box5 from '@/components/home/box5.vue'
import box6 from '@/components/home/box6.vue'
import box7 from '@/components/home/box7.vue'
export default {
	components:{ 
		box1,
		box2,
		box3,
		box4,
		box5,
		box6,
		box7
	},
	data(){
		return {}
	},
	methods:{
		download(){
			// this.$message.success('目前系统还有一些细节方面需要再完善完善，请再等待一些时间...')
		}
	}
}
</script>
<style lang='less'>
	.home-box{
		position: relative;
		width:100%;
		height:100%;
		background: #1a1a39;
		.home-bg{
			position: absolute;
			width:100%;
			height:100%;
			left:0;
			top:0;
			bottom:0;
			right:0;
			overflow: hidden;
			img{
				width:100%;
				height:100%;
			}
		}
		.head{
			position: absolute;
			width:50%;
			height:122px;
			left:25%;
			top:0;
			z-index: 2;
			display: flex;
			justify-content: center;
			background:url('../../assets/home_images/head_bg.png') center top no-repeat;
			.head-bg{
				height:74px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.head-l{
				width:74px;
				height:74px;
				background:url('../../assets/home_images/head_l.png') no-repeat;
			}
			.head-c{
				width:auto;
				height:74px;
				background:url('../../assets/home_images/head_c.png') 0 0 repeat-x;
				display: flex;
				align-items: center;
				justify-content: center;
				padding:0 20px;
				h1{
					font-size:32px;
					color:#fff;
					font-weight: normal;
				}
			}
			.head-r{
				width:74px;
				height:74px;
				background:url('../../assets/home_images/head_r.png') no-repeat;
			}
		}
		.go-system{
			position: absolute;
			width:150px;
			right:35px;
			top:22px;
			z-index: 999;
			cursor: pointer;
			img{
				width:100%;
				height:auto
			}
		}
		.home-left{
			position: absolute;
			width:32%;
			height:100%;
			left:0;
			top:0;
			background: linear-gradient(to right, rgba(13,19,33,1) 0, rgba(13,19,33,.75) 75%, transparent 100%);
			z-index: 9;
			.home_pad{
				width:100%;
				height:100%;
				box-sizing: border-box;
				padding-top: 80px;
				padding-left:30px;
				position: relative;
				overflow: hidden;
				.main-left-top{
					width:75%;
					padding:15px 0;
					height:36%;
					box-sizing: border-box;
					overflow: hidden;
				}
				.main-left-cen{
					width:75%;
					padding:15px 0;
					height:36%;
					box-sizing: border-box;
					overflow: hidden;
				}
				.main-left-bot{
					padding:15px 0;
					height:28%;
					box-sizing: border-box;
				}
			}
		}
		.home-right{
			position: absolute;
			width:32%;
			height:100%;
			right:0;
			top:0;
			background: linear-gradient(to left, rgba(13,19,33,1) 0, rgba(13,19,33,.8) 65%, transparent 100%);
			z-index: 9;
			.home_pad{
				width:100%;
				height:100%;
				box-sizing: border-box;
				padding-top: 80px;
				padding-right:30px;
				position: relative;
				overflow-y: hidden;
				background:url('../../assets/home_images/right_bottom.png') right bottom no-repeat;
				.main-right-cen{
					padding:15px 0;
					height:23.33%;
					width:75%;
					box-sizing: border-box;
					float: right;
				}
				.main-right-bot{
					padding:15px 0;
					width:100%;
					height:30%;
					box-sizing: border-box;
					float: right;
				}
			}
		}
		.left-top, .right-top{
			position: absolute;
			width:19.94%;
			left:0;
			top:0;
			z-index: 10;
			img{
				width:100%;
				height:auto
			}
		}
		.right-top{
			width:23.489%;
			left: auto;
			right:0;

		}
	}
	
	
</style>